import {IImages, IModel} from "../../../kova/slsordClient";
import React, {useState} from "react";
import {SiteSpecificDiv,} from "../vscSiteSpecific/SiteSpecific";
import styled from "@emotion/styled/macro";
import {CameraCard} from "../vscFindYourHome/CameraCards";
import {getItemsForTab, useModelConfig} from "../vscSiteSpecific/UseModelConfig";
import {ViewTabs} from "../../ViewTabs";
import Switch from "../vscSiteSpecific/Switch";
import AdminPortal from "../../admin/AdminPortal";
import PlanAdmin from "./PlanAdmin";
import {useModelConfigurator} from "./UseModelConfigurator";
import {ConfiguratorSelections} from "./ConfiguratorSelections";
import {filterViewItems} from "../../../data/IViewpoint";
import {SiteSpecific3DMap} from "../vscSiteSpecific/SiteSpecific3DMap";
import {SiteSpecific2DMap} from "../vscSiteSpecific/SiteSpecific2DMap";
import {getViewOptions} from "../../../data/getViewOptions";
import {VscBigScreenWebPage} from "../../content/ButtonComponent";
import {useVscContext} from "../../content/VscReactContext";
import {VscVideoPlayer} from "../../video/VscVideoPlayer";


export interface IPlanProps {
    model: IModel;
}


export const PlanLayout = styled.div`

  display: flex;
  height:100%;
  flex-direction: column;
    .content {
      height:calc(100% - 80px);
    }
  .footer {
    background-color: white;
    display:flex;
    align-items: center;
    justify-content: center;
    height:80px;
  }
  .selections {
    overflow-y: auto;
  }
    
`

const Plan: React.FC<IPlanProps> = (props) => {

    const [viewItemIndex, setViewItemIndex] = useState<number>(0);
    const [activeViewTab, setActiveViewTab] = useState<string | null>(null);
    const [showFurniture, setShowFurniture] = useState<boolean>(false);

    const vscContext = useVscContext();
    const {model} = props;
    const modelConfig = useModelConfig(model.id ?? "");
    const lotId = modelConfig?.lotId ?? "GenLot";


    const {configurator, onSelect} = useModelConfigurator(model);

    const viewTabs = modelConfig?.views.map(v => v.name) ?? [];
    const activeTabToUse = activeViewTab ?? viewTabs[0] ?? "";
    const allViewItems = getItemsForTab(activeTabToUse, modelConfig);
    const viewItems = filterViewItems(allViewItems, ["plan"]);

    let selectedViewItem = viewItems[viewItemIndex];
    if (!selectedViewItem) {
        selectedViewItem = viewItems[0];
    }
    const viewOptions = getViewOptions(selectedViewItem, showFurniture);

    if (configurator === null || modelConfig === null) {
        return <div>Loading plan...</div>;
    }

    return <PlanLayout>

        <AdminPortal>
            {modelConfig && <PlanAdmin modelConfig={modelConfig} model={model} activeCamera={selectedViewItem?.name}
                                       configurator={configurator}/>}
        </AdminPortal>
        <div className={"content"}>
            <SiteSpecificDiv>
                { (selectedViewItem.type === "camera" || selectedViewItem.type === "viewpoint") && <SiteSpecific3DMap lotId={lotId} selectedViewItem={selectedViewItem} modelConfig={modelConfig} /> }
                { selectedViewItem.type === "map" && <SiteSpecific2DMap lotId={lotId} selectedViewItem={selectedViewItem}/> }
                { selectedViewItem.type === "image" && selectedViewItem.image && <VscBigScreenWebPage url={`StaticContent.html?shared=global&image=${encodeURIComponent(vscContext.getVisualizerContentUri(selectedViewItem.image))}`} /> }
                { selectedViewItem.type === "video" && <VscVideoPlayer videoName={selectedViewItem.video} videoTitle={selectedViewItem.name} looping={selectedViewItem.looping ?? false} /> }

                <div className={"views"}>
                    <ViewTabs viewTabs={viewTabs} activeViewTab={activeTabToUse}
                              onSetActiveViewTab={(tabName: string) => {
                                  setViewItemIndex(0);
                                  setActiveViewTab(tabName);
                              }}/>
                    <div className={"cameras"}>
                        {viewItems.map((cam, idx) => <CameraCard key={idx} camera={cam} isActive={idx === viewItemIndex}
                                                                 onClick={() => setViewItemIndex(idx)}/>)}
                    </div>
                </div>
                <div className={"selections"}>
                    <ConfiguratorSelections configurator={configurator} optionsVisible={modelConfig?.options}
                                            onSelect={onSelect} lotId={lotId} viewOptions={viewOptions}
                    />
                </div>
            </SiteSpecificDiv>
        </div>
        <div className={"footer"}>

            <Switch checked={showFurniture} onChange={() => setShowFurniture(old => !old)}>Furniture</Switch>
        </div>
    </PlanLayout>
}

export default Plan;